import { render, staticRenderFns } from "./Assessor.vue?vue&type=template&id=6c653cc5&"
import script from "./Assessor.vue?vue&type=script&lang=js&"
export * from "./Assessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports